var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    width: "18px",
    height: "18px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 247.1 247.1",
    enableBackground: "new 0 0 247.1 247.1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000000",
    strokeWidth: 6.0376,
    strokeMiterlimit: 10,
    d: "M43.1,123.8c0,6.4,5.1,11.7,11.2,11.7h117 l-32.7,44.7c-1.8,2.4-2.5,5.3-2,8.2c0.5,2.9,2.1,5.5,4.5,7.3c1.9,1.4,4.2,2.1,6.6,2.1c3.6,0,7-1.7,9.1-4.6l45.7-62.8 c0,0,0.1-0.1,0.1-0.1c0.3-0.4,0.6-0.9,0.8-1.4c0.5-1.1,0.9-2.2,1.1-3.3c0.1-0.7,0.1-1.2,0.1-1.8c0-0.5,0-1.1-0.1-1.7 c-0.2-1.2-0.5-2.3-1-3.3c0,0,0-0.1-0.1-0.1c-0.2-0.4-0.5-0.9-0.8-1.3c-0.1-0.1-0.1-0.2-0.2-0.3l-45.7-62.8c-2.1-2.9-5.5-4.7-9.1-4.7 c-2.4,0-4.6,0.7-6.5,2.1c-2.4,1.8-4,4.4-4.5,7.3c-0.5,2.9,0.3,5.8,2,8.3l32.7,44.7h-117C48.3,112,43.1,117.4,43.1,123.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.ea0a9bc55a091e21b7c5d766af396e29.svg";
export { ForwardRef as ReactComponent };